import type { FunctionComponent } from "react";
import type { IProps } from "./stepped-flow-step.types";

/**
 * Declares one step of a stepped flow (SteppedModal, SteppedDrawer). The shell renders the step's label in its
 * header stepper and this component's children in its body when the step is active. `label` is read from this
 * element by the shell rather than used here.
 */
const SteppedFlowStep: FunctionComponent<IProps> = ({ children }) => {
    return <>{children}</>;
};

export { SteppedFlowStep };
